import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=18fb0669&scoped=true&lang=pug&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&id=18fb0669&prod&scoped=true&lang=sass&"
import style1 from "./Player.vue?vue&type=style&index=1&id=18fb0669&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb0669",
  null
  
)

export default component.exports